<template>
  <div class="d-flex flex-direction-row">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>